import { Navigate } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';
import { useOfficerApproval } from '../../modules/auth/hooks/useOfficerApproval';
import Spinner from '../../shared/components/Spinner';
import PublicDashboard from '../../modules/PublicDashboard';
import AdminDashboard from '../../modules/AdminDashboard';
import { ROLES } from '../../shared/constant/roles';

function HomeRoute() {
  const { user, role, profileCompleted, loading } = useAuth();
  const isDashboardRole = role === ROLES.OFFICER || role === ROLES.ADMIN || role === ROLES.SUPER_ADMIN;
  const shouldCheckApproval = Boolean(user) && profileCompleted && isDashboardRole;
  const { approved, loading: approvalLoading } = useOfficerApproval(shouldCheckApproval);

  if (loading || (shouldCheckApproval && approvalLoading)) {
    return <Spinner />;
  }

  if (!user) {
    return <PublicDashboard />;
  }

  if (!profileCompleted) {
    return <Navigate to="/complete-profile" replace />;
  }

  if (isDashboardRole) {
    if (!approved) {
      return <Navigate to="/pending-approval" replace />;
    }
    return <AdminDashboard />;
  }

  return <Navigate to="/login" replace />;
}

export default HomeRoute;
